"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _pick2 = _interopRequireDefault(require("lodash/pick"));

var _react = _interopRequireDefault(require("react"));

var _OverlayTrigger = _interopRequireDefault(require("rsuite-utils/lib/Overlay/OverlayTrigger"));

var PickerToggleTriggerProps = ['onEntered', 'onExited', 'open', 'defaultOpen', 'disabled', 'placement', 'onEnter', 'onEntering', 'onExit', 'onExiting', 'onHide', 'container', 'containerPadding'];

var PickerToggleTrigger =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2["default"])(PickerToggleTrigger, _React$Component);

  function PickerToggleTrigger() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PickerToggleTrigger.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        innerRef = _this$props.innerRef,
        pickerProps = _this$props.pickerProps,
        rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["innerRef", "pickerProps"]);
    return _react["default"].createElement(_OverlayTrigger["default"], (0, _extends2["default"])({
      trigger: "click",
      ref: innerRef
    }, (0, _pick2["default"])(pickerProps, PickerToggleTriggerProps), rest));
  };

  return PickerToggleTrigger;
}(_react["default"].Component);

(0, _defineProperty2["default"])(PickerToggleTrigger, "handledProps", ["innerRef"]);
var _default = PickerToggleTrigger;
exports["default"] = _default;